import React from 'react';
import './text-block.css';
const BlankBlock = () => <div className="blank-block" />;

export default BlankBlock;



// WEBPACK FOOTER //
// ./src/components/shared/text-block/blank-block.jsx